import { useLayoutEffect, useCallback } from 'react';

import { usePostman } from '../usePostman';

import {
  postmanKey,
  Sizes,
  SizeVariables,
  SizesProps,
  ititSizes,
  ServiceMargins,
} from './common';

let ScpSizesStore: Sizes = ititSizes;

export function useProviderElementSizes(sizes: SizesProps): void {
  const postman = usePostman();

  const updateSizes = useCallback(
    (updSizes: SizesProps) => {
      ScpSizesStore = {
        ...ScpSizesStore,
        ...updSizes,
      };
      const { bannerHeight, topbarHeight, navigationDrawerMobileHeight } =
        ScpSizesStore;

      const margins: ServiceMargins = {
        ...ScpSizesStore, // для обратной совместимости с useHeaderSize
        topMargin: bannerHeight + topbarHeight,
        bottomMargin: navigationDrawerMobileHeight,
      };

      Object.getOwnPropertyNames(margins).forEach(key => {
        document.documentElement.style.setProperty(
          `--scp-${SizeVariables[key as keyof ServiceMargins]}`,
          `${margins[key as keyof ServiceMargins]}px`,
        );
      });

      if (postman) {
        postman.send(postmanKey, margins);
      }
    },
    [postman],
  );

  useLayoutEffect(() => {
    updateSizes(sizes);

    return () => {
      const cleanedSizes = Object.getOwnPropertyNames(sizes).reduce(
        (acc, name) => ({
          ...acc,
          [name]: 0,
        }),
        {},
      );

      updateSizes(cleanedSizes);
    };
  }, [postman, sizes, updateSizes]);
}
